"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IA_JOB_STATUS_PERCENT = exports.IA_JOB_STATUS_TEXT_MAP = exports.IA_JOB_STATUS = void 0;

var _IA_JOB_STATUS_PERCEN;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Job status is not a typical enum field; it's a freeform text field. Typical values:
// Submitted
// In Progress
// 93% complete
// Completed
// The enum values listed here are unique to the web viewer. The List Jobs API reports status as text. Enum's are more
// predictable so we have to convert them. The conversion occurs in the API Access Layer (AAL) in platform / data
// services. Note that "STARTING" and "ACTIVE" technically map to the same state; it's just that progress reporting
// only occurs in what's listed as the "Active" state.
var IA_JOB_STATUS = {
  UNKNOWN: -100,
  ERROR: -1,
  QUEUED: 0,
  // Maps to "Submitted"
  STARTING: 1,
  // Maps to "In Progress"
  ACTIVE: 2,
  // Maps to "\d% complete"
  COMPLETED: 3,
  // Maps to "Completed"
  CANCEL_REQUESTED: 11,
  // Maps to "Cancel Requested"
  CANCELLED: 12 // Maps to "Cancelled"

}; // This table is a reverse-lookup that attempts to map known API states to the enum values above. Since this field is
// a free-text field in the database it is possible that AAF may create additional states.

exports.IA_JOB_STATUS = IA_JOB_STATUS;
var IA_JOB_STATUS_TEXT_MAP = {
  'Failed': IA_JOB_STATUS.ERROR,
  'Submitted': IA_JOB_STATUS.QUEUED,
  'In Progress': IA_JOB_STATUS.STARTING,
  '%d complete': IA_JOB_STATUS.ACTIVE,
  'Completed': IA_JOB_STATUS.COMPLETED,
  'Requested Cancel': IA_JOB_STATUS.CANCEL_REQUESTED,
  'Cancelled': IA_JOB_STATUS.CANCELLED
}; // Maps status to percent. Generally it's 0 or 100, unless the job is active, in which case we extract it from the raw val.

exports.IA_JOB_STATUS_TEXT_MAP = IA_JOB_STATUS_TEXT_MAP;
var IA_JOB_STATUS_PERCENT = (_IA_JOB_STATUS_PERCEN = {}, _defineProperty(_IA_JOB_STATUS_PERCEN, IA_JOB_STATUS.ACTIVE, function (val) {
  var _val$match = val.match(/((\d+)%|\w+)/),
      _val$match2 = _slicedToArray(_val$match, 3),
      progress = _val$match2[2];

  return Number(progress);
}), _defineProperty(_IA_JOB_STATUS_PERCEN, IA_JOB_STATUS.COMPLETED, function () {
  return 100;
}), _defineProperty(_IA_JOB_STATUS_PERCEN, "DEFAULT", 0), _IA_JOB_STATUS_PERCEN);
exports.IA_JOB_STATUS_PERCENT = IA_JOB_STATUS_PERCENT;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/image-analysis/jobs/consts.js
// module id = 45
// module chunks = 0